import { combineReducers } from "redux";
import { BlockReducer, BlockStatusReducer, contactsWhoBlockedMeReducer } from "./BlockReducer";
import { BroadCastReducer } from "./BroadCastReducer";
import {
  CallConnectionStateReducer,
  callConversionReducer,
  pinUserReducer,
  largeVideoUserReducer,
  callDurationTimestampReducer,
  callQualityReducer,
  callQualityPopupReducer,
  callQualityIconReducer
} from "./CallReducer";
import { showConfrenceReducer } from "./confrenceReducer";
import { ConnectionStateReducer } from "./ConnectionStateReducer";
import { FeatureStateReducer } from "./FeatureStateReducer";
import { ConversationState } from "./ConversationState";
import {
  GroupChatMediaReducer,
  GroupChatMessageReducer,
  GroupChatSelectedMediaReducer
} from "./GroupChatMessageReducer";
import {
  GroupsMemberListReducer,
  GroupsReducer,
  currentCallGroupMembersReducer,
  GroupsMemberParticipantsListReducer
} from "./GroupsReducer";
import { LastActivityReducer } from "./LastActivityReducer";
import { MessageEditedReducer, messageForwardReducer, messageInfoReducer, MessageReducer, ReplyMessageReducer , selectedMessageInfoReducer} from "./MessageReducer";
import { PopUp } from "./PopUp";
import { PresenceReducer } from "./PresenceReducer";
import {
  RecentChatReducer,
  ActiveChatReducer,
  WebChatProfileImageReducer,
  modalPopUpReducer
} from "./RecentChatReducer";
import { RecentChatStatusReducer } from "./RecentChatStatusReducer";
import RosterReducer from "./RosterReducer";
import {
  SingleChatMediaReducer,
  SingleChatMessageReducer,
  SingleChatSelectedMediaReducer,
  chatSeenPendingMsgReducer
} from "./SingleChatMessageReducer";
import { TypingReducer } from "./TypingReducer";
import { UnreadCountReducer, UnreadUserObjReducer } from "./UnreadCountReducer";
import { VCardContactReducer, VCardReducer } from "./VCardReducer";
import { callLogReducer } from "./CallLogReducer";
import { browserNotifyReducer, browserTabReducer, appOnlineStatusReducer, webLocalStorageSettingReducer } from "./BrowserReducer";
import { scrollBottomChatHistoryReducer } from "./ScrollReducer";
import { ChatConversationHistoryReducer, EditStatusReducer, LoadMoreChatsMessagesReducer } from "./ChatHistory";
import { MediaDownloadStateReducer, MediaDropdownStatusReducer, MediaImageThumbDataReducer, UpdateMediaDownloadStateReducer, UpdateMediaUploadStateReducer } from "./Media";
import { starMsgPageTypeReducer, StarredMessagesReducer } from "./StarredReducer";
import { TranslateLanguage } from "./TranslateLanguage";
import { CommonDataReducer } from "./CommonReducer";
import { callIntermediateScreenReducer } from "./CallIntermediateScreen";
import { RosterPermissionReducer } from "./RosterPermissionReducer";
import { AdminBlockReducer } from "./AdminBlockReducer";
import { SettingsReducer } from "./SettingsDataReducer";
import { PrivacySettingsReducer } from "./PrivacySettingsReducer";
import toastMessageSlice from '../Slice/toastMessageSlice';
import channelNavSlice from '../Slice/channelNavSlice';
import leftPaneNavSlice from '../Slice/leftPaneNavSlice';
import recentChannelListSlice from '../Slice/recentChannelSlice';
import channelInfoSlice from '../Slice/channelInfoSlice';
import channelConversationSlice from '../Slice/channelConversationSlice';
import alertModalSlice from '../Slice/alertModalSlice';
import actionModalSlice from '../Slice/actionModalSlice';
import userInfoSlice from '../Slice/userInfoSlice'
import draftSlice from '../Slice/draftSlice'
import channelSelectionSlice from '../Slice/channelSelectionSlice'
import invitationsSlice from '../Slice/invitationsSlice'
import progressDataSlice from '../Slice/progressDataSlice'
import channelMediaPreviewSlice from '../Slice/channelMediaPreviewSlice'
import channelMembersSlice from '../Slice/channelMembersSlice'
import channelCategoryReducer from "../channels/utils/channelActions/ChannelCategoryReducer";
import menuReducer from "../channels/utils/channelActions/menuActiveStatus";
import exploreChannelsSlice from '../Slice/explorechannel';
import themeSlice from '../Slice/themeSlice';
import selectedUserSlice from '../Slice/selectedUserSlice';
import { commonReducer } from '../Slice/commonSlice';
import { callkitDataReducer } from '../features/calls/model/callkitDataSlice';
import activeCallLogData from '../Slice/activeCallLogSlice';

import WallpaperReducer from "./WallpaperReducer";
import { ReactionReducer } from "./ReactionReducer";


export default combineReducers({
  TranslateLanguage:TranslateLanguage,
  modalPopUpReducer: modalPopUpReducer,
  ConnectionStateData: ConnectionStateReducer,
  featureStateData: FeatureStateReducer,
  vCardData: VCardReducer,
  rosterData: RosterReducer,
  recentChatData: RecentChatReducer,
  recentChatStatus: RecentChatStatusReducer,
  conversationState: ConversationState,
  messageData: MessageReducer,
  activeChatData: ActiveChatReducer,
  WebChatProfileImageData: WebChatProfileImageReducer,
  VCardContactData: VCardContactReducer,
  groupsData: GroupsReducer,
  blockedContact: BlockReducer,
  blockStatus: BlockStatusReducer,
  lastActivityData: LastActivityReducer,
  singleChatMsgHistoryData: SingleChatMessageReducer,
  groupsMemberListData: GroupsMemberListReducer,
  groupsMemberParticipantsListData: GroupsMemberParticipantsListReducer,
  presenceData: PresenceReducer,
  typingData: TypingReducer,
  replyMessageData: ReplyMessageReducer,
  selectedMessageData: messageForwardReducer,
  messageInfoData: messageInfoReducer,
  groupChatMessage: GroupChatMessageReducer,
  callConnectionDate: CallConnectionStateReducer,
  showConfrenceData: showConfrenceReducer,
  SingleChatMediaData: SingleChatMediaReducer,
  GroupChatMediaData: GroupChatMediaReducer,
  SingleChatSelectedMediaData: SingleChatSelectedMediaReducer,
  GroupChatSelectedMediaData: GroupChatSelectedMediaReducer,
  unreadCountData: UnreadCountReducer,
  UnreadUserObjData: UnreadUserObjReducer,
  broadCastData: BroadCastReducer,
  popUpData: PopUp,
  currentCallGroupMembersData: currentCallGroupMembersReducer,
  callLogData: callLogReducer,
  callConversionData: callConversionReducer,
  pinUserData: pinUserReducer,
  largeVideoUserData: largeVideoUserReducer,
  callDurationTimestampData: callDurationTimestampReducer,
  browserNotifyData: browserNotifyReducer,
  contactsWhoBlockedMe: contactsWhoBlockedMeReducer,
  scrollBottomChatHistory: scrollBottomChatHistoryReducer,
  browserTabData: browserTabReducer,
  appOnlineStatus: appOnlineStatusReducer,
  chatSeenPendingMsgData: chatSeenPendingMsgReducer,
  chatConversationHistory: ChatConversationHistoryReducer,
  chatEditStatus: EditStatusReducer,
  messageEditedData: MessageEditedReducer,
  mediaUploadData: UpdateMediaUploadStateReducer,
  mediaDownloadingData: UpdateMediaDownloadStateReducer,
  starredMessages: StarredMessagesReducer,
  webLocalStorageSetting : webLocalStorageSettingReducer,
  commonData: CommonDataReducer,
  callIntermediateScreen: callIntermediateScreenReducer,
  contactPermission: RosterPermissionReducer,
  adminBlockData: AdminBlockReducer,
  selectedMessageInfoReducer: selectedMessageInfoReducer,
  mediaDownloadData: MediaDownloadStateReducer,
  mediaDropDownData: MediaDropdownStatusReducer,
  mediaImageThumbData : MediaImageThumbDataReducer,
  LoadMoreChatsMessages: LoadMoreChatsMessagesReducer,
  callQualityData: callQualityReducer,
  callQualityPopup: callQualityPopupReducer,
  callQualityIcon: callQualityIconReducer,
  starMsgPageType: starMsgPageTypeReducer,
  settingsData: SettingsReducer,
  privacySettingsData: PrivacySettingsReducer,
  toastMessageData: toastMessageSlice,
  channelNavData: channelNavSlice,
  leftPaneNavData: leftPaneNavSlice,
  recentChannelListData: recentChannelListSlice,
  channelInfoData: channelInfoSlice,
  channelConversationData: channelConversationSlice,
  alertModalData: alertModalSlice,
  actionModalData: actionModalSlice,
  userInfoData: userInfoSlice,
  draftData: draftSlice,
  channelSelectionData: channelSelectionSlice,
  invitations: invitationsSlice,
  progressData: progressDataSlice,
  channelMediaPreviewData: channelMediaPreviewSlice,
  channelMembersData:channelMembersSlice,
  channelCategory: channelCategoryReducer,
  menu: menuReducer,
  exploreChannelsSlice: exploreChannelsSlice,
  themeData: themeSlice,
  selectedUserData: selectedUserSlice,
  wallpaperData: WallpaperReducer,
  reactionData: ReactionReducer,
  common: commonReducer,
  callkitData: callkitDataReducer,
  activeCallLogData: activeCallLogData
});


